import { render, staticRenderFns } from "./LocationTopicResponsibleForm.vue?vue&type=template&id=f5214764&scoped=true"
import script from "./LocationTopicResponsibleForm.vue?vue&type=script&lang=ts"
export * from "./LocationTopicResponsibleForm.vue?vue&type=script&lang=ts"
import style0 from "./LocationTopicResponsibleForm.vue?vue&type=style&index=0&id=f5214764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5214764",
  null
  
)

export default component.exports